import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';


@Injectable()
export class NewMessageService {
    constructor(private http: Http) { }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/app/clmtlk/new-message/shared/new-message.service.ts